import { render } from "./MatchingDetail.vue?vue&type=template&id=e2a08310&scoped=true"
import script from "./MatchingDetail.vue?vue&type=script&lang=js"
export * from "./MatchingDetail.vue?vue&type=script&lang=js"

import "@/assets/css/layout_product.css?vue&type=style&index=0&id=e2a08310&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a08310"]])

export default __exports__